<template>
  <div>
    <b-col md="12">
      <card class="data-card mt-4 mr-3 ml-3" :show-footer-line="true">
        <div class="d-flex align-items-center justify-content-between pb-3">
          <h2>
            تراکنش های دستی
          </h2>
          <div class="d-flex align-items-center justify-content-end">
            <b-select style="width: 200px" class="ml-2" v-model="filterData.type">
              <b-select-option value="CRYPTO_TRANSACTION">
                تراکنش های رمزارزی
              </b-select-option>
              <b-select-option value="FIAT_TRANSACTION">
                تراکنش های تومانی
              </b-select-option>
            </b-select>
            <date-picker
              clearable
              class="date-picker"
              v-model="date"
              placeholder="انتخاب تاریخ"
              :auto-submit="true"
              range
            />
          </div>
        </div>


        <b-row>
          <b-col v-if="loading" md="12">
            <b-card class="wallets-table p-5" no-body>
              <BaseLoading/>
            </b-card>
          </b-col>
          <b-col v-if="!loading" md="12">
            <b-card class="wallets-table" no-body>
              <b-table
                emptyText="تاریخچه ای یافت نشد"
                :items="data"
                :fields="fields"
                show-empty
                responsive
                small
              >

                <template #cell(user)="row">
                  <div v-if="!accountId">
                    <b-button
                      v-if="row.item.user"
                      variant="primary"
                      size="sm"
                      @click="$router.push('/user-profile/'+row.item.user.id);">
                    <span v-if="row.item.user.firstName && row.item.user.lastName">
                      {{ row.item.user.firstName + ' ' + row.item.user.lastName }}
                    </span>
                      <span v-else>
                    {{ row.item.user.cellPhone.number }}
                    </span>
                    </b-button>
                  </div>
                </template>

                <template #cell(amount)="row">
                  <div class="d-flex align-items-center justify-content-end">

                    <div class="ml-2 d-flex item-center justify-content-start flex-column">
                      <span>
                    {{ addCommas(row.item.amount) }}
                  </span>
                      <span>
                       {{ row.item.asset }}
                     </span>
                    </div>
                    <CryptoIcons :symbol="row.item.asset"/>
                  </div>
                </template>

                <template #cell(type)="row">
                  <b-badge variant="info" v-if="row.item.type === 'CryptoIncrease'">
                    واریز رمزارز
                    <b-icon-arrow-down/>
                  </b-badge>
                  <b-badge variant="primary" v-if="row.item.type === 'CryptoDecrease'">
                    برداشت رمزارز
                    <b-icon-arrow-up/>
                  </b-badge>

                  <b-badge variant="info" v-if="row.item.type === 'FiatIncrease'">
                    واریز تومانی
                    <b-icon-arrow-down/>
                  </b-badge>
                  <b-badge variant="primary" v-if="row.item.type === 'FiatDecrease'">
                    برداشت تومانی
                    <b-icon-arrow-up/>
                  </b-badge>

                </template>

                <template #cell(description)="row">
                  {{ row.item.description }}
                </template>
              </b-table>
            </b-card>
            <div class="paginationNav">
              <b-row>
                <b-col class="mt-4">
                  <BasePagination
                    :showNext="true"
                    :showPrev="filterData.page !== 0"
                    @onClick="handlePaginationClick"
                  />
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </card>
    </b-col>
  </div>
</template>
<script>

import CryptoIcons from "@/components/CryptoIcons";
import BasePagination from "@/components/BasePagination.vue";
import filterAndPaginate from "@/mixins/filterAndPaginate";
import BaseDatePicker from "@/components/Inputs/BaseDatePicker";
import dateHelper from "@/utils/DateHelper";
import {fetchDustingReportDetail, fetchDustingReports} from "@/httpservices/Dusting";
import {addCommas} from "@persian-tools/persian-tools";
import http from "@/httpservices/HttpService";
import moment from "jalali-moment";
import Swal from "sweetalert2";
import store from "@/store";
import {fetchUserAccount} from "@/httpservices/User";
import BaseLoading from "@/components/BaseLoading";


export default {
  components: {
    BaseLoading,
    CryptoIcons,
    BaseDatePicker,
    BasePagination,
  },

  props: {
    accountId: {
      type: String,
    }
  },

  data() {
    return {

      data: [],
      date: [],
      loading: false,
      transitionsTypes: [
        {
          id: "CRYPTO_TRANSACTION",
          label: "تراکنش های رمز ارزی",
        },
        {
          id: "FIAT_TRANSACTION",
          label: "تراکنش های تومانی",
        },
      ],
      filterData: {
        page: 0,
        pageSize: 25,
        start: undefined,
        end: undefined,
        symbol: undefined,
        type: "CRYPTO_TRANSACTION",
      },
    };
  },


  mounted() {
    this.fetchData();
  },

  computed: {
    fields() {
      if (this.accountId) {
        return [
          {
            key: "date",
            label: "تاریخ",
          },
          {
            key: "type",
            label: "نوع",
          },
          {
            key: "amount",
            label: "مبلغ",
          },
          {
            key: "description",
            label: "توضیحات",
          },
        ];
      } else {
        return [
          {
            key: "user",
            label: "کاربر",
          },
          {
            key: "date",
            label: "تاریخ",
          },
          {
            key: "type",
            label: "نوع",
          },
          {
            key: "amount",
            label: "مبلغ",
          },
          {
            key: "description",
            label: "توضیحات",
          },
        ];
      }

    }
  },

  methods: {
    addCommas,

    handlePaginationClick(value) {
      this.filterData.page = value;
      this.fetchData();
    },


    async fetchData() {
      this.loading = true;
      try {
        const actions = {
          CRYPTO_TRANSACTION: `AdminReports/manual-balance-change/crypto/page/${this.filterData.page}`,
          FIAT_TRANSACTION: `AdminReports/manual-balance-change/fiat/page/${this.filterData.page}`
        }
        const res = await http.get(actions[this.filterData.type], {
          params: {
            ...this.filterData,
            AccountId: this.accountId,
          }
        });
        this.data = await Promise.all(res.data.data.map(async item => {
          const user = (await fetchUserAccount(item.accountId)).data || {};
          return {
            id: item.id,
            user: user,
            amount: item.amount,
            date: moment.utc(item.date).locale('fa').format('jYYYY-jMM-jDD HH:mm'),
            type: item.type,
            asset: item.asset,
            description: item.details,
          }
        }));
      } catch (e) {
        console.log(e)
      }
      this.loading = false;
    },

  },

  watch: {
    date(value) {
      console.log({value})
      const getDate = (dateTime) => {
        return moment.from(dateTime, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD');
      };
      this.filterData.start = getDate(value[0]);
      this.filterData.end = getDate(value[1]);
      this.fetchData();
    },

    'filterData.type'() {
      this.fetchData();
    }
  }
};
</script>


<style>
.table thead th {
  text-align: center !important;
}
</style>
